var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVolleyballBall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 52,
    viewBox: "0 0 48 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_418_3612)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.9989 20.0003C43.9849 23.1026 43.2559 26.16 41.8685 28.9348C40.4811 31.7096 38.4726 34.1272 35.9992 35.9998C33.464 37.9012 30.5133 39.1729 27.3903 39.7101C24.2672 40.2474 21.0612 40.0348 18.0364 39.09C15.0116 38.1451 12.2547 36.495 9.99274 34.2756C7.73081 32.0561 6.02865 29.331 5.02655 26.3247C4.02444 23.3184 3.75108 20.1169 4.22898 16.9842C4.70688 13.8516 5.92237 10.8773 7.77528 8.3065C9.62818 5.73573 12.0655 3.64206 14.8863 2.19804C17.7071 0.754016 20.8306 0.000976563 23.9996 0.000976562C35.2292 0.141639 44.1236 9.05068 43.9989 20.0003Z",
    fill: "#FFC239"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9997 0.0012027C21.1197 -0.0307093 18.2681 0.572792 15.6479 1.76873C13.0278 2.96466 10.7036 4.72361 8.84084 6.92031C7.63287 10.9533 7.72817 15.2647 9.11318 19.2404C10.4982 23.2161 13.1023 26.6535 16.5546 29.063C20.007 31.4726 24.1315 32.7314 28.341 32.6603C32.5504 32.5892 36.6301 31.1917 39.9991 28.6669C41.1473 27.803 42.1979 26.8166 43.1324 25.725C43.6873 23.8667 43.979 21.9398 43.999 20.0005C44.1237 9.05024 35.2293 0.141865 23.9997 0.0012027Z",
    fill: "#FFD55D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9989 20.0005C44.0338 16.8896 43.3262 13.8153 41.9349 11.0327C40.5437 8.25015 38.5088 5.83953 35.9991 4.00098C37.6385 12.0049 36.2109 20.3326 31.9993 27.3336L33.1992 31.9787L38.9944 33.216C42.1911 29.5522 43.9669 24.8628 43.9989 20.0005Z",
    fill: "#FFC239"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.333 1.06738V31.3764H35.0448C36.8164 30.7124 38.4846 29.7999 39.9993 28.6665C41.1475 27.8026 42.1982 26.8161 43.1326 25.7246C43.6875 23.8663 43.9792 21.9394 43.9992 20.0001C44.0288 15.8016 42.7199 11.7029 40.2626 8.29861C37.8052 4.89428 34.3272 2.36139 30.333 1.06738Z",
    fill: "#FFD55D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9744 3.98903C32.501 1.43443 28.311 0.0390853 23.9995 0.00116308C21.37 -0.0102175 18.7642 0.499312 16.3327 1.50034C13.9011 2.50137 11.6919 3.97408 9.83248 5.83346C7.9731 7.69284 6.50039 9.90208 5.49936 12.3336C4.49833 14.7652 3.98881 17.371 4.00019 20.0005L5.16681 18.7339C7.97195 15.7186 11.4206 13.3743 15.2563 11.8752C19.0921 10.3761 23.2164 9.76075 27.3227 10.0748C27.3227 10.0748 32.5306 6.70294 36.0444 4.35502L35.9744 3.98903Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.266 0.741179C27.5492 0.271226 25.7794 0.0225546 23.9995 0.0012027C21.1195 -0.0307093 18.2679 0.572792 15.6478 1.76873C13.0277 2.96466 10.7035 4.72361 8.84071 6.92031C7.78607 10.4513 7.72333 14.2044 8.65939 17.7686H29.266V0.741179Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2977 30.0002C38.3324 29.8527 35.431 29.0851 32.7807 27.7469C30.1304 26.4087 27.7901 24.5297 25.9109 22.2311L23.9997 20.0005L17.6379 19.7686L14 23.3338C16.1064 26.4936 18.8332 29.1922 22.0147 31.2656C25.1963 33.3391 28.7661 34.7441 32.5074 35.3954L35.9993 36C38.1541 34.3802 39.9568 32.3388 41.2977 30.0002Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9109 22.2311L23.9997 20.0005L17.6379 19.7686L14 23.3338C16.4263 26.9707 19.6703 29.9891 23.4723 32.1475C24.9568 32.4919 26.4756 32.6662 27.9995 32.6668C31.725 32.6709 35.3768 31.629 38.5392 29.6596C33.5764 28.7745 29.0957 26.1387 25.9109 22.2311Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3207 10.0752C20.4663 9.56484 13.6685 11.6333 8.26001 15.875C8.77663 19.0812 10.0702 22.1122 12.0279 24.7034C13.9665 23.1791 16.1586 22.0085 18.5037 21.2455L23.9995 20.0008L25.6961 16.401C26.7014 14.4395 27.2564 12.2784 27.3207 10.0752Z",
    fill: "#173E67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.16664 18.7336L4.00002 20.0002C3.99552 23.5116 4.92035 26.9616 6.68059 29.9999C8.24519 28.0283 10.0404 26.2512 12.0277 24.7067C10.0696 22.1146 8.77598 19.0824 8.25987 15.875C7.15449 16.7442 6.12014 17.7001 5.16664 18.7336Z",
    fill: "#112F4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5139 24.3449C12.6519 24.2442 12.7892 24.1449 12.9292 24.0469C12.7892 24.1442 12.6519 24.2442 12.5139 24.3449Z",
    fill: "#FFC239"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9294 24.0468C13.333 23.7646 13.7434 23.4964 14.1607 23.2422C13.7425 23.4968 13.3321 23.7651 12.9294 24.0468Z",
    fill: "#FFC239"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5141 24.3447C12.3514 24.4634 12.1881 24.5807 12.0281 24.7034C12.1881 24.5807 12.3514 24.4667 12.5141 24.3447Z",
    fill: "#FFC239"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0046 27.3281C36.2112 20.3292 37.6368 12.0061 35.9991 4.00619C32.7079 1.58035 28.766 0.194955 24.6808 0.0283203L25.2808 1.14828C27.86 6.25078 28.014 11.9406 25.6935 16.3991L23.9995 20.001L25.9101 22.2303C27.5936 24.3069 29.6631 26.038 32.0046 27.3281Z",
    fill: "#1F5389"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_418_3612",
    x: 0,
    y: 0,
    width: 48.0002,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_418_3612"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_418_3612",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolleyballBall);
export default __webpack_public_path__ + "static/media/volleyball-ball.c93a586043e23deecf366294df7d6dea.svg";
export { ForwardRef as ReactComponent };